import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {BranchHeaderContainerModel} from '../../../../../../models/aggregates/branch';
import {Core2Config} from '../../shared/core2Config';


@Injectable({
  providedIn: 'root'
})
export class BranchHdrService extends BaseApiTemplateService<BranchHeaderContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branches-hdrs';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branches-hdrs';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branches-hdrs';
    this.httpClient = http;
  }

}
